import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {ControlStatus} from '../ControlStatus'
import {ControlStatusModule} from '../ControlStatusModule'
import {ControlStatusRoom} from '../ControlStatusRoom'
const HeaderControlStatusPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            {/* <Tab className={'sdx_sub_tab_panel_option'}>Control y Estado de Módulos</Tab> */}
            {/* <Tab className={'sdx_sub_tab_panel_option'}>Control y Estado de Habitaciones</Tab> */}
            <Tab className={'sdx_sub_tab_panel_option'}>Control y Estado de Camas</Tab>
            {/* <Tab className={'sdx_sub_tab_panel_option'}>Control y Estado de Huéspedes</Tab> */}
          </TabList>
          {/* <TabPanel>
            <ControlStatusModule />
          </TabPanel>
          <TabPanel>
            <ControlStatusRoom />
          </TabPanel> */}
          <TabPanel>
            <ControlStatus />
          </TabPanel>
          {/* <TabPanel>
            <ControlStatusModule />
          </TabPanel> */}
        </Tabs>
      </div>
    </>
  )
}

export {HeaderControlStatusPanel}
